import React, { useState, useEffect } from 'react';
import EditForm from '../../components/Campaigns/Page/EditForm';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import useApiManager from '../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';

const EditCampaign = () => {
    const [campaignData, setCampaignData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { get, put } = useApiManager();
    const { campaignId } = useParams();



    const fetchCampaignData = async () => {
        try {
            const data = await get(`/campaigns/${campaignId}`);
            setCampaignData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCampaignData();
        document.title = "Edit Campaign - iLead CRM";
    }, []);

    const handleFormSubmit = async (formData) => {
        //console.log('Form Submitted:', formData);
        // Handle form submission logic here (e.g., send data to an API)
        try {
            const responseData = await put(`/campaigns/${campaignId}`, formData);
            console.log('Form Submitted Successfully:', responseData);
            goBack();
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };

    const goBack = () => {
        navigate(-1); // -1 goes back in history, equivalent to history.goBack()
    };

    return (
        <Box sx={{ p: 5 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h3>Edit Campaign</h3>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Button variant="outlined" onClick={() => goBack()}>Cancel</Button>

                        <Button variant="contained" type="submit" form="create-form">Save</Button>
                    </Box>
                </Box>
                <Divider aria-hidden="true" sx={{ borderWidth: "thin" }} />
                <EditForm campaignData={campaignData} onSubmit={handleFormSubmit} loading={loading} />
            </Paper >
        </Box>
    )
};

export default EditCampaign;
